import { DocumentSubtype, ProjectType, ProjectsConfig } from 'const';
import { RootDocumentMap } from 'models';

export const allowImageMobileSettings = (projectType: ProjectType, rootDocument: RootDocumentMap): boolean => {
  return ProjectsConfig[projectType].allowImageMobileSettings && rootDocument.get('subtype') !== DocumentSubtype.MAGIC_FORM;
};
